<template>
    <div id="application">
        <div class="search-box">
            <p>客户端IP：</p>
            <a-input allow-clear v-model="clientIp"/>
            <p>用户名：</p>
            <a-input allow-clear v-model="userName"/>
            <p>模块名：</p>
            <a-input allow-clear v-model="module"/>
            <p>请求时间：</p>
            <a-range-picker
                :show-time="{ format: 'HH:mm:ss' }"
                format="YYYY-MM-DD HH:mm:ss"
                :placeholder="['开始时间', '结束时间']"
                @change="onChange"
                @ok="onOk"
            />
            <a-button type="primary" icon="search" class="search-btn" @click="refreshTable">搜索</a-button>
        </div>
        <a-table
            rowKey="id"
            :columns="columns"
            :data-source="data"
            :pagination="pagination"
            :loading="loading"
            @change="handleTableChange"
            bordered
        >
            <span slot="idNum">{{pagination.pageSize}}</span>
            <span slot="result" slot-scope="text">{{text?'成功':'失败'}}</span>
            <span slot="action" slot-scope="text, record">
                <a @click="details(record)">详情</a>
            </span>
            <template slot="name" slot-scope="name"> {{ name.first }} {{ name.last }} </template>
        </a-table>
        <a-drawer
            title="日志详情"
            placement="right"
            :closable="false"
            :visible="showAdd"
            :width=500
            @close="showAdd=false"
        >
            <div class="input-box">
                <p>用户名：</p>
                <div class="text-box">{{rowObj.userId}}</div>
            </div>
            <div class="input-box">
                <p>用户名称：</p>
                <div class="text-box">{{rowObj.userName}}</div>
            </div>
            <div class="input-box">
                <p>部门：</p>
                <div class="text-box">{{rowObj.orgName}}</div>
            </div>
            <div class="input-box">
                <p>模块名称：</p>
                <div class="text-box">{{rowObj.moduleName}}</div>
            </div>
            <div class="input-box">
                <p>客户端IP：</p>
                <div class="text-box">{{rowObj.clientIp}}</div>
            </div>
            <div class="input-box">
                <p>时间：</p>
                <div class="text-box">{{rowObj.createTime}}</div>
            </div>
            <div class="input-box">
                <p>响应结果：</p>
                <div class="text-box">{{rowObj.response}}</div>
            </div>
            <div class="input-box">
                <p>操作结果：</p>
                <div class="text-box">{{rowObj.resultText}}</div>
            </div>
            <div class="input-box">
                <p>请求url：</p>
                <div class="text-box">{{rowObj.url}}</div>
            </div>
            <div class="input-box">
                <p>请求参数：</p>
                <div class="text-box">{{rowObj.request}}</div>
            </div>
            <div class="drawer-btn">
                <a-button @click="showAdd=false">关闭</a-button>
            </div>
        </a-drawer>
    </div>
</template>

<script>
const columns = [
    {
        title: '序号',
        dataIndex: 'idNum',
    },
    {
        title: '用户名',
        dataIndex: 'userId',
    },
    {
        title: '用户名称',
        dataIndex: 'userName',
    },
    {
        title: '部门',
        dataIndex: 'orgName',
    },
    {
        title: '模块名称',
        dataIndex: 'moduleName',
    },
    {
        title: '客户端IP',
        dataIndex: 'clientIp',
    },
    {
        title: '时间',
        dataIndex: 'createTime',
    },
    {
        title: '操作结果',
        dataIndex: 'result',
        scopedSlots: { customRender: 'result' },

    },
    {
        title: '操作',
        dataIndex: 'action',
        width: 150,
        scopedSlots: { customRender: 'action' },
    },
];
export default {
  name: 'Application',
  components: {
  },
  data() {
    return {
        data: [],
        pagination: {},
        loading: false,
        columns,
        clientIp:'',
        userName:'',
        module:'',
        stateDate:'',
        endDate:'',
        tableSize:'10',
        rowObj:{
            userName:'',
            orgName:'',
            moduleName:'',
            clientIp:'',
            createTime:'',
            resultText:'',
            url:'',
            request:'',
        },
        showAdd: false,
    }
  },
  mounted () {
    this.refreshTable();
  },
  methods:{
    handleTableChange(pagination) {
      const pager = { ...this.pagination };
      pager.current = pagination.current;
      this.pagination = pager;
      this.fetch({
        size: pagination.pageSize,
        current: pagination.current,
        name:this.name,
        code:this.code,
      });
    },
    fetch(params = {}) {
        this.pagination = params;
        this.loading = true;
        this.baseAPI.axiosData('/api-l/logs?size='+params.size+'&current='+params.current+'&clientIp='+this.clientIp+'&userName='+this.userName+'&module='+this.module+'&startDate='+this.stateDate+'&endDate='+this.endDate,'get',{}).then(res => {
            const pagination = { ...this.pagination };
            params.size+=''
            pagination.pageSize = params.size-0;
            pagination.total = res.data.total;
            for(let i=0;i<res.data.records.length;i++)
            {
                res.data.records[i].idNum=(params.size*(params.current-1))+i+1;
            }
            this.loading = false;
            this.data = res.data.records;
            console.log(this.data)
            this.pagination = pagination;
        })
    },
    refreshTable(){
        this.fetch({
            size: this.tableSize,
            current: 1,
            name:this.name,
            code:this.code,
        });
    },
    onChange(value, dateString) {
        this.stateDate=dateString[0];
        this.endDate=dateString[1];
    },
    onOk(value) {
      console.log('onOk: ', value);
    },
    details(obj)
    {
        this.rowObj=obj;
        this.rowObj.resultText=obj.result?'成功':'失败';
        this.showAdd=true;
    }
  }
}
</script>

<style scoped>
    .search-box
    {
        padding-bottom: 24px;
        border-bottom: 1px solid rgba(151,151,151,0.60);
        margin-bottom: 24px;
    }
    .search-box p
    {
        display: inline-block;
        margin-left: 2rem;
    }
    .search-box p:nth-child(1)
    {
        margin-left: 0;
    }
    .search-box .ant-input-affix-wrapper
    {
        width: 14rem;
    }
    .search-box .search-btn
    {
        margin-left: 2rem;
    }
    .input-box
    {
        margin-bottom: 1rem;
    }
    .input-box p
    {
        display: inline-block;
        vertical-align: top;
        width: 20%;
        text-align: right;
    }
    .input-box .text-box
    {
        display: inline-block;
        padding-left: 1rem;
        border-bottom: 1px solid #d9d9d9;
        width: 80%;
        line-height: 2rem;
    }
    .anticon
    {
        font-size: 20px;
        margin-right: 1rem;
        cursor: pointer;
    }
    .anticon:hover
    {
        color: #1890ff;
    }
    a{
      display: inline-block;
      text-decoration: none;
      color: #1F5EFF;
    }
    .drawer-btn
    {
        position: absolute;
        width: 100%;
        right: 0;
        bottom: 0;
        border-top: 1px solid #e9e9e9;
        padding: 10px 16px;
        text-align: right;
        z-index: 1;
    }
</style>
